import { useState } from "react";
import type { LoginFlowState } from "./types";

export function useLoginFlow() {
  const [admissionNo, setAdmissionNo] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [isdCode, setIsdCode] = useState("+91");
  const [loginFlowState, setLoginFlowState] =
    useState<LoginFlowState>("enterAdmissionNo");

  const goToAdmissionNo = () => setLoginFlowState("enterAdmissionNo");
  const goToPassword = () => setLoginFlowState("enterPassword");
  const goToOtp = () => setLoginFlowState("enterOtp");

  return {
    admissionNo,
    setAdmissionNo,
    mobileNumber,
    setMobileNumber,
    isdCode,
    setIsdCode,
    loginFlowState,
    setLoginFlowState,
    goToAdmissionNo,
    goToPassword,
    goToOtp,
  };
}
